import { graphql } from "@/lib/gql/__generated__";

export const ContactInfo = graphql(/* GraphQL */ `
	query ContactInfo($hotelID: ID!) {
		hotel(hotelID: $hotelID) {
			id
			email
		}
	}
`);
